import { apiCall } from '../../../Middleware/API/apiRequest';
import { getTokensFromStorage } from '../../../Utils/Auth/AuthToken';

const { accessToken } = getTokensFromStorage();

/**
 * Get Stats for Crads on Dashboard
 * @returns {Promise} - A promise that resolves with the list of stats or rejects with an error.
 * @param props
 */
export const getTotalCounts = async ({
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const response = await apiRequest({
    url: `/stats`,
    method: 'GET',
    moduleName,
    isServiceWorker,
    listController,
    accessToken,
  });
  if (!response?.isSuccess) {
    if (isServiceWorker) {
      let cacheResponse = await getGraphqlCacheResponse(
        headers,
        isServiceWorker
      );
      return cacheResponse;
    }
    return response;
  }
  if (isServiceWorker) {
    await setGraphqlCacheResponse(headers, response, isServiceWorker);
  }

  return {
    isSuccess: response?.isSuccess,
    stats: response?.payload
  };
};

/**
 * Get Rollout count based on the project
 * @returns {Promise} - A promise that resolves with the result  or rejects with an error.
 * @param props
 */
export const getRolloutProjectsData = async ({
  moduleName,
  isServiceWorker,
  listController,
  data,
}) => {
  const response = await apiRequest({
    url: `/rollouts/project/graph`,
    method: 'POST',
    moduleName,
    isServiceWorker,
    listController,
    accessToken,
    body: JSON.stringify(data),
  });
  if (!response?.isSuccess) {
    if (isServiceWorker) {
      let cacheResponse = await getGraphqlCacheResponse(
        headers,
        isServiceWorker
      );
      return cacheResponse;
    }
    return response;
  }
  if (isServiceWorker) {
    await setGraphqlCacheResponse(headers, response, isServiceWorker);
  }

  return {
    isSuccess: response?.isSuccess,
    payload: response?.payload
  };
};

/**
 * Get Rollout Activities Data
 * @returns {Promise} - A promise that resolves with the result  or rejects with an error.
 * @param props
 */
export const getRolloutActivitiesData = async ({
  moduleName,
  isServiceWorker,
  listController,
  data
}) => {
  const response = await apiRequest({
    url: `/rollouts/activity`,
    method: 'POST',
    moduleName,
    isServiceWorker,
    listController,
    accessToken,
    body: JSON.stringify(data),
  });
  if (!response?.isSuccess) {
    if (isServiceWorker) {
      let cacheResponse = await getGraphqlCacheResponse(
        headers,
        isServiceWorker
      );
      return cacheResponse;
    }
    return response;
  }
  if (isServiceWorker) {
    await setGraphqlCacheResponse(headers, response, isServiceWorker);
  }

  return {
    isSuccess: response?.isSuccess,
    payload: response?.payload
  };
};

/**
 * Get Rollout with bugs included in it
 * @returns {Promise} - A promise that resolves with the result  or rejects with an error.
 * @param props
 */
export const getBugsinRolloutAnalytics = async ({
  moduleName,
  isServiceWorker,
  listController,
  data,
}) => {
  const response = await apiRequest({
    url: `/rollouts/bugs-over-time`,
    method: 'POST',
    moduleName,
    isServiceWorker,
    listController,
    accessToken,
    body: JSON.stringify(data),
  });
  if (!response?.isSuccess) {
    if (isServiceWorker) {
      let cacheResponse = await getGraphqlCacheResponse(
        headers,
        isServiceWorker
      );
      return cacheResponse;
    }
    return response;
  }
  if (isServiceWorker) {
    await setGraphqlCacheResponse(headers, response, isServiceWorker);
  }

  return {
    isSuccess: response?.isSuccess,
    payload: response?.payload
  };
};

/**
 * Get Affected Files By Repos
 * @param {*} moduleName 
 * @param {*} isServiceWorker 
 * @param {*} listController 
 * @param {*} data 
 * @returns 
 */
export const getAffectedFilesByRepos = async ({
  moduleName,
  isServiceWorker,
  listController,
  data
}) => {
  const response = await apiRequest({
    url: `/rollouts/affected-files-by-repo`,
    method: 'POST',
    moduleName,
    isServiceWorker,
    listController,
    accessToken,
    body: JSON.stringify(data),
  });
  if (!response?.isSuccess) {
    if (isServiceWorker) {
      let cacheResponse = await getGraphqlCacheResponse(
        headers,
        isServiceWorker
      );
      return cacheResponse;
    }
    return response;
  }
  if (isServiceWorker) {
    await setGraphqlCacheResponse(headers, response, isServiceWorker);
  }

  return {
    isSuccess: response?.isSuccess,
    payload: response?.payload
  };
};

/**
 * Api Call Wrapper Method.
 * @param {object} api - Contains details like url headers method and data.
 * @returns {Promise} - A promise that resolves with the data or rejects with an error.
 */
const apiRequest = async (request) => {
  let response;
  const headers = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  };
  request.headers = headers;
  try {
    response = await apiCall(request);

    if (!response.isSuccess) {
      return { isSuccess: false, message: response.message };
    }
    return response;
  } catch (e) {
    response = { isSuccess: false, message: e.message };
  }
  return response;
};
